module.exports = __webpack_public_path__ + "static/media/call_status_ringing.9648c769.svg";